import { AnimationMode } from '../types/models';

function isProductionEnv(): boolean {
  return import.meta.env.PROD;
}

export function isLocalViewerBypassHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function isViewerUrlBypassEnabled(): boolean {
  const explicitFlag = import.meta.env.VITE_ENABLE_VIEWER_URL_BYPASS === 'true';
  return !isProductionEnv() && explicitFlag;
}

export function getModelFromQuery(): string {
  if (typeof window === 'undefined') return 'pergola';
  const params = new URLSearchParams(window.location.search);
  return params.get('model') || 'pergola';
}

export function getCustomGlbUrl(): string | null {
  if (typeof window === 'undefined') return null;
  if (!isViewerUrlBypassEnabled()) return null;
  const params = new URLSearchParams(window.location.search);
  let url = params.get('glbUrl') || params.get('modelUrl') || null;

  if (url && url.includes('glbUrl=')) {
    url = url.split('glbUrl=')[1] || url;
  }

  return url;
}

export function getAnimationModeFromQuery(): AnimationMode {
  if (typeof window === 'undefined') return 'step_by_step';
  const params = new URLSearchParams(window.location.search);
  const mode = params.get('animationMode') || params.get('mode');

  if (mode === 'exploded_view' || mode === 'exploded-view') {
    return 'exploded_view';
  }

  return 'step_by_step';
}

export function shouldUseSceneCameraFromQuery(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('useSceneCamera') === 'true';
}

export function getBackgroundFromQuery(fallback: string): string {
  if (typeof window === 'undefined') return fallback;
  const params = new URLSearchParams(window.location.search);
  return params.get('background') || fallback;
}

export function getAutoFocusFromQuery(defaultValue: boolean): boolean {
  if (typeof window === 'undefined') return defaultValue;
  const params = new URLSearchParams(window.location.search);
  const value = params.get('autoFocus');
  return value === 'true' ? true : value === 'false' ? false : defaultValue;
}

export function isAdminViewFromQuery(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const admin = params.get('admin');
  const view = params.get('view');
  return admin === 'true' || view === 'admin';
}

export function isEmbedModeFromQuery(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('embed') === 'true';
}
